import { h, Host } from "@stencil/core";
/**
 * A button with a confirmation modal.
 * @slot before - Placed before the main content with correct padding.
 * @slot after - Placed after the main content with correct padding.
 * @part button - The button.
 */
export class EsActionWithConfirmation {
    constructor() {
        this.requestDeletion = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.open = true;
        };
        this.closeModal = () => {
            this.open = false;
        };
        this.takingAction = false;
        this.takeActionAndClose = async () => {
            if (this.takingAction || !this.open)
                return;
            this.takingAction = true;
            await this.action();
            this.open = false;
            this.takingAction = false;
        };
        this.variant = 'default';
        this.type = 'button';
        this.disabled = false;
        this.action = undefined;
        this.typeToConfirm = undefined;
        this.modal = undefined;
        this.open = false;
    }
    render() {
        return (h(Host, { key: '235228b5029dba1287e6ce4f1068bef72bb998ab' }, h("es-button", { key: '0673d18e3cbe8282acc155e4c09f9a65df0e29dc', onClick: this.requestDeletion, variant: this.variant, disabled: this.disabled, part: 'button' }, h("slot", { key: '5b7cda4ffb6fb7a8b70a65cd701a63a4c3149e09', name: 'before', slot: 'before' }), h("slot", { key: 'f7284d1bc8ff6d41b7216f6ae73988fd36667ebd' }), h("slot", { key: 'a220ccdf85d5b43307baf0ba752098b7111b16c4', name: 'after', slot: 'after' })), !this.disabled && (h("es-portal", { key: 'cf46a5ecfc1962f1a70726c9d31a4dcc7a45df20', backdrop: true, open: this.open, onRequestClose: this.closeModal, renderElement: () => (h("es-confirm-modal", { onRequestDeletion: this.takeActionAndClose, typeToConfirm: this.typeToConfirm, ...this.modal })) }))));
    }
    static get is() { return "es-button-with-confirmation"; }
    static get encapsulation() { return "shadow"; }
    static get properties() {
        return {
            "variant": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "ButtonVariant",
                    "resolved": "\"cancel\" | \"default\" | \"delete\" | \"filled\" | \"link\" | \"minimal\" | \"outline\"",
                    "references": {
                        "ButtonVariant": {
                            "location": "import",
                            "path": "../types",
                            "id": "src/components/buttons/types.ts::ButtonVariant"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Which styling variant to use."
                },
                "attribute": "variant",
                "reflect": true,
                "defaultValue": "'default'"
            },
            "type": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The default behavior of the button."
                },
                "attribute": "type",
                "reflect": false,
                "defaultValue": "'button'"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If the button is disabled. Prevents the user from interacting with the button: it cannot be pressed or focused."
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "action": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "() => any",
                    "resolved": "() => any",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The action to be called on click."
                }
            },
            "typeToConfirm": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "If the user needs to type the passed string to enable confirmation."
                },
                "attribute": "type-to-confirm",
                "reflect": false
            },
            "modal": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "ConfirmModalOptions",
                    "resolved": "ConfirmModalOptions",
                    "references": {
                        "ConfirmModalOptions": {
                            "location": "import",
                            "path": "../../modals/es-confirm-modal/types",
                            "id": "src/components/modals/es-confirm-modal/types.ts::ConfirmModalOptions"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The text to display within the modal."
                }
            }
        };
    }
    static get states() {
        return {
            "open": {}
        };
    }
    static get elementRef() { return "host"; }
}
//# sourceMappingURL=es-button-with-confirmation.js.map
